import React from 'react';
import {AisinoCheckbox, AisinoFormItem} from "../../../baseComponent/form";
import {AisinoCol, AisinoRow} from "../../../baseComponent/rowAndCol";
import {postSync} from "../../utils/http";
import {formItemTailLayout} from "../../../constant/css";

const CheckboxGroup = AisinoCheckbox.Group;
let checkboxOptions = {};
class FormItemDictCheckbox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            optionsData: '',
        };
    }

    componentDidMount() {
        const typeCode = this.props.typecode;

        const optionList =  checkboxOptions[typeCode.toString()];
        //判断选项是否已存在，如果存在，直接用；
        // 如果不存在，从后台接口查询，并保存数据字典 checkboxOptions变量里（已备下次使用，减少接口调用，优化体验）
        if (optionList){
            this.setOptionsData(optionList);
        } else {
            postSync('aisino/portalIndex/getDictByTypeCode', {typeCode:typeCode}).then(response => {
                //console.log("response=====FormItemDictCheckbox====" + JSON.stringify(response));
                if (response) {
                    const optionList = response;
                    this.setOptionsData(optionList);
                    checkboxOptions[typeCode.toString()] = optionList;
                }
            });
        }
    }

    componentWillUnmount() {
        this.setState = ()=>false;
    }


    setOptionsData(optionList){
        let children = [];
        for (let i = 0; i < optionList.length; i++) {
            children.push(
                <AisinoCol span={this.props.boxSpan?this.props.boxSpan:24} key={optionList[i].name+i}>
                    <AisinoCheckbox  key={optionList[i].name} value={optionList[i].value} style={{ lineHeight: '32px' }}>
                        {optionList[i].name}
                    </AisinoCheckbox>
                </AisinoCol>);
        }
        this.setState({optionsData:children});
    }

    render() {
        return(
            <AisinoFormItem {...formItemTailLayout} {...this.props} onChange={this.props.onChangeItem}>
                <CheckboxGroup disabled={this.props.disabled} onChange={this.props.onChange}>
                    <AisinoRow>
                        {this.state.optionsData}
                    </AisinoRow>
                </CheckboxGroup>
            </AisinoFormItem>
        );
    }
}

export default FormItemDictCheckbox;